import { gql } from '@apollo/client'
import React from 'react'

import { mapPointsClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import { useMapState } from '../../../../components/map/MapContext'
import { convertMapBboxToAPIBbox } from '../_helper'
import Loading from '../../../../packages/kiti/components/helpers/Loading'

const Context = React.createContext([])
const { Provider } = Context
export const useMapPointsState = () => React.useContext(Context)
export const useMapPoints = () => {
  const result = useMapPointsState()?.data?.mapPoints || []

  const filtered = result.filter(r => r.total > 1)
  return filtered
}

export const useGroupedMapPoints = () => {
  const result = useMapPointsState()?.data?.mapPoints || []
  const filtered = result.filter(r => r.total === 1)
  const grupos = filtered.reduce((acumulador, valorAtual, index, array) => {
    const key = `${valorAtual.latitude}_${valorAtual.longitude}`
    const grupo = acumulador[key] || []

    grupo.push(valorAtual)
    acumulador[key] = grupo
    return acumulador
  }, {})

  return grupos
}

const QUERY = gql`
  query MapPoints($filter: MapPointFilter) {
    mapPoints(filter: $filter) {
      recordId
      recordType
      name
      total
      latitude
      longitude
      minLatitude
      minLongitude
      maxLatitude
      maxLongitude
      clusterId
    }
  }
`

const MapPointsLoader = ({ children }) => {
  const { zoom, bounds, showUser, showPlaces, controller } = useMapState()
  const convertedBounds = convertMapBboxToAPIBbox(bounds)

  const recordTypes = showPlaces || showUser ? [] : null
  if (showUser) {
    recordTypes.push('contracts')
  }
  if (showPlaces) {
    recordTypes.push('location')
  }
  const { data, loading, previousData } = useQuery(QUERY, {
    variables: {
      filter: {
        recordTypes,
        zoomLevel: zoom,
        ...convertedBounds
      }
    },
    options: {
      context: { fetchOptions: { signal: controller.signal } }
    },
    client: mapPointsClient
  })

  return (
    <Provider value={{ data: data || previousData, loading }}>
      <>
        {children}
        {loading && (
          <div
            style={{
              top: 'calc(100% - 3rem)',
              left: 'calc(100% - 50%)',
              position: 'absolute'
            }}
          >
            <Loading />
          </div>
        )}
      </>
    </Provider>
  )
}

export default MapPointsLoader
